export const DeliveryOptions = {
  DeliveryAsap: "DeliveryAsap",
  DeliveryLater: "DeliveryLater",
  DeliveryMuchLater: "DeliveryMuchLater"
}
